<bm-indicator
  [indicator]="indicator"
  [index]="index"
  (value)="indicator.noteSelected = $event"
  [error]="false"
></bm-indicator>
